import styled from 'styled-components';

const VerticalSeparator = styled.span`
  align-self: stretch;
  width: 1px;
  background-color: #c3c3c3;
`;

export { VerticalSeparator };
